'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

let ClaimsEventComponents = /*#__PURE__*/function (ClaimsEventComponents) {
  ClaimsEventComponents["NTH_KIT_CLAIMS_ORDER_LOOKUP"] = "NTH_KIT_CLAIMS_ORDER_LOOKUP";
  ClaimsEventComponents["NTH_KIT_CLAIMS_ITEM_SELECTION"] = "NTH_KIT_CLAIMS_ITEM_SELECTION";
  ClaimsEventComponents["NTH_KIT_CLAIMS_ITEM_QUANTITY"] = "NTH_KIT_CLAIMS_ITEM_QUANTITY";
  ClaimsEventComponents["NTH_KIT_CLAIMS_ITEM_PHOTO"] = "NTH_KIT_CLAIMS_ITEM_PHOTO";
  ClaimsEventComponents["NTH_KIT_CLAIMS_ITEM_ADDITIONAL_INFO"] = "NTH_KIT_CLAIMS_ITEM_ADDITIONAL_INFO";
  ClaimsEventComponents["NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY"] = "NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY";
  ClaimsEventComponents["NTH_KIT_CLAIMS_SHIPMENT_SELECTION"] = "NTH_KIT_CLAIMS_SHIPMENT_SELECTION";
  ClaimsEventComponents["NTH_KIT_CLAIMS_SHIPMENT_ADDITIONAL_INFO"] = "NTH_KIT_CLAIMS_SHIPMENT_ADDITIONAL_INFO";
  ClaimsEventComponents["NTH_KIT_CLAIMS_SHIPMENT_CLAIM_SUMMARY"] = "NTH_KIT_CLAIMS_SHIPMENT_CLAIM_SUMMARY";
  ClaimsEventComponents["NTH_KIT_CLAIMS_CONFIRMATION"] = "NTH_KIT_CLAIMS_CONFIRMATION";
  return ClaimsEventComponents;
}({});
let ClaimsEventTypes = /*#__PURE__*/function (ClaimsEventTypes) {
  ClaimsEventTypes["PAGE_LOAD"] = "PAGE_LOAD";
  ClaimsEventTypes["ORDER_LOOKUP_CLICK_NEXT"] = "ORDER_LOOKUP_CLICK_NEXT";
  ClaimsEventTypes["ORDER_LOOKUP_SUCCESS"] = "ORDER_LOOKUP_SUCCESS";
  ClaimsEventTypes["ORDER_LOOKUP_FAILURE"] = "ORDER_LOOKUP_FAILURE";
  ClaimsEventTypes["ORDER_LOOKUP_REASON_SELECTION"] = "ORDER_LOOKUP_REASON_SELECTION";
  ClaimsEventTypes["ORDER_LOOKUP_CLAIM_POLICY_CLICK"] = "ORDER_LOOKUP_CLAIM_POLICY_CLICK";
  ClaimsEventTypes["ITEM_SELECTED"] = "ITEM_SELECTED";
  ClaimsEventTypes["ITEM_QUANTITY_SELECTED"] = "ITEM_QUANTITY_SELECTED";
  ClaimsEventTypes["ITEM_QUANTITY_NEXT"] = "ITEM_QUANTITY_NEXT";
  ClaimsEventTypes["ITEM_QUANTITY_BACK"] = "ITEM_QUANTITY_BACK";
  ClaimsEventTypes["ITEM_PHOTO_UPLOADED"] = "ITEM_PHOTO_UPLOADED";
  ClaimsEventTypes["ITEM_PHOTO_UPLOADED_FAILED"] = "ITEM_PHOTO_UPLOADED_FAILED";
  ClaimsEventTypes["ITEM_PHOTO_NEXT"] = "ITEM_PHOTO_NEXT";
  ClaimsEventTypes["ITEM_PHOTO_BACK"] = "ITEM_PHOTO_BACK";
  ClaimsEventTypes["SHIPMENT_SELECTED"] = "SHIPMENT_SELECTED";
  ClaimsEventTypes["ADDITIONAL_INFO_CHECKBOX"] = "ADDITIONAL_INFO_CHECKBOX";
  ClaimsEventTypes["ADDITIONAL_INFO_NEXT_COMMENTED"] = "ADDITIONAL_INFO_NEXT_COMMENTED";
  ClaimsEventTypes["ADDITIONAL_INFO_NEXT_NO_COMMENT"] = "ADDITIONAL_INFO_NEXT_NO_COMMENT";
  ClaimsEventTypes["ADDITIONAL_INFO_BACK"] = "ADDITIONAL_INFO_BACK";
  ClaimsEventTypes["SHIPMENT_DETAILS_EXPANDED"] = "SHIPMENT_DETAILS_EXPANDED";
  ClaimsEventTypes["ADD_COMMENT"] = "ADD_COMMENT";
  ClaimsEventTypes["REMOVE_ITEM_CLICK"] = "REMOVE_ITEM_CLICK";
  ClaimsEventTypes["ITEM_SELECTED_NEXT"] = "ITEM_SELECTED_NEXT";
  ClaimsEventTypes["ITEM_SELECTED_BACK"] = "ITEM_SELECTED_BACK";
  ClaimsEventTypes["SHIPMENT_SELECTED_NEXT"] = "SHIPMENT_SELECTED_NEXT";
  ClaimsEventTypes["SHIPMENT_SELECTED_BACK"] = "SHIPMENT_SELECTED_BACK";
  ClaimsEventTypes["REMOVE_SHIPMENT_CLICK"] = "REMOVE_SHIPMENT_CLICK";
  ClaimsEventTypes["REVIEW_SIGNATURE_INPUT"] = "REVIEW_SIGNATURE_INPUT";
  ClaimsEventTypes["REVIEW_CONFIRMATION_CHECKED"] = "REVIEW_CONFIRMATION_CHECKED";
  ClaimsEventTypes["REVIEW_SUBMIT_CLICK"] = "REVIEW_SUBMIT_CLICK";
  ClaimsEventTypes["REVIEW_SUBMIT_BACK"] = "REVIEW_SUBMIT_BACK";
  ClaimsEventTypes["REVIEW_SUBMIT_SUCCESS"] = "REVIEW_SUBMIT_SUCCESS";
  ClaimsEventTypes["REVIEW_SUBMIT_FAILURE"] = "REVIEW_SUBMIT_FAILURE";
  ClaimsEventTypes["CONTINUE_SHOPPING_CLICK"] = "CONTINUE_SHOPPING_CLICK";
  return ClaimsEventTypes;
}({});
let ClaimsPageStep = /*#__PURE__*/function (ClaimsPageStep) {
  ClaimsPageStep["ORDER_LOOKUP"] = "ORDER_LOOKUP";
  ClaimsPageStep["SELECTION"] = "SELECTION";
  ClaimsPageStep["SELECTION_QUANTITY"] = "SELECTION_QUANTITY";
  ClaimsPageStep["SELECTION_PHOTO"] = "SELECTION_PHOTO";
  ClaimsPageStep["SELECTION_COMMENT"] = "SELECTION_COMMENT";
  ClaimsPageStep["REVIEW_SUBMIT"] = "REVIEW_SUBMIT";
  ClaimsPageStep["CONFIRMATION"] = "CONFIRMATION";
  return ClaimsPageStep;
}({});
const AnalyticsContext = /*#__PURE__*/React.createContext(undefined);
const AnalyticsProvider = AnalyticsContext.Provider;
const useAnalytics = () => {
  const context = React.useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within a AnalyticsProvider');
  }
  const {
    noflakeUrl,
    retailerMoniker,
    localeCountry,
    localeLanguage,
    source,
    errorCallback
  } = context;
  const logEvent = React.useCallback(event => {
    if (typeof window === 'undefined' || !noflakeUrl) {
      return;
    }
    const {
      document: {
        referrer: pageReferrerUrl
      },
      location: {
        href: pageUrl
      }
    } = window;
    const dateTime = new Date().toISOString();
    const noflakePayload = {
      ...event,
      tag: 'noflake.assist_fe',
      event_ts: dateTime,
      ingestion_timestamp: dateTime,
      retailer_moniker: retailerMoniker,
      page_locale_country: localeCountry,
      page_locale_language: localeLanguage,
      page_url: pageUrl,
      page_referrer_url: pageReferrerUrl,
      source
    };
    fetch(noflakeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(noflakePayload)
    }).catch(err => {
      if (errorCallback) {
        errorCallback(err);
      }
    });
  }, [retailerMoniker, localeCountry, localeLanguage, source, noflakeUrl, errorCallback]);
  const logEventRef = React.useRef(logEvent);
  React.useEffect(() => {
    logEventRef.current = logEvent;
  }, [logEventRef, logEvent]);
  return React.useCallback(function () {
    return logEventRef.current(...arguments);
  }, [logEventRef]);
};

exports.AnalyticsProvider = AnalyticsProvider;
exports.ClaimsEventComponents = ClaimsEventComponents;
exports.ClaimsEventTypes = ClaimsEventTypes;
exports.ClaimsPageStep = ClaimsPageStep;
exports["default"] = useAnalytics;
